import React, { useState } from 'react'
import { PaymentElement, useCheckout } from '@stripe/react-stripe-js/checkout'

export default function CheckoutForm() {
  const [message, setMessage] = useState(null)
  const [isSubmitting, setIsSubmitting] = useState(false)

  const checkoutState = useCheckout()

  const handleSubmit = async (e) => {
    e.preventDefault()

    const { checkout } = checkoutState
    setIsSubmitting(true)

    const confirmResult = await checkout.confirm()

    // This point will only be reached if there is an immediate error when
    // confirming the payment. Otherwise, your customer will be redirected to
    // your `return_url`. For some payment methods like iDEAL, your customer will
    // be redirected to an intermediate site first to authorize the payment, then
    // redirected to the `return_url`.
    if (confirmResult.type === 'error') {
      setMessage(confirmResult.error.message)
    }

    setIsSubmitting(false)
  }

  return (
    <>
      {checkoutState.type === 'loading' && <div>Loading...</div>}
      {checkoutState.type === 'error' && <div>Error: {checkoutState.error.message}</div>}
      {checkoutState.type === 'success' && (
        <form onSubmit={handleSubmit}>
          <h4>Choix du mode de paiement</h4>
          <PaymentElement id='payment-element' />
          <button disabled={!checkoutState.checkout.canConfirm || isSubmitting} id='submit'>
            {isSubmitting ? <div className='spinner'></div> : `Payer ${checkoutState.checkout.total.total.amount}`}
          </button>
          {/* Show any error or success messages */}
          {message && <div id='payment-message'>{message}</div>}
        </form>
      )}
    </>
  )
}
